import React, { Component } from "react";
import "./App.css";
import "basscss/css/basscss-cp.min.css";
import "basscss-border-colors/css/border-colors.css";

import { createClient } from "contentful";
import { StyleRoot } from "radium";
import { Router, Route } from "react-router-dom";
import { connect } from "react-redux";

import ScrollToTop from "./components/ScrollToTop";
import Menu from "./components/Menu";
import FixedHeader from "./components/FixedHeader";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Post from "./pages/Post";
import About from "./pages/About";
import Archives from "./pages/Archives";
import Trends from "./pages/Trends";
import Request from "./pages/Request";
import GA from "react-ga";
import createHistory from "history/createBrowserHistory";

const contentfulClientConfig = {
  space: "adjv5is9m9cf",
  accessToken: "66237cf3200fff313bb82a16999bccb8ade1ff1957e05824ee8eaeb7b9efdd5e",
};

// if(process.env.REACT_APP_PREVIEW) {
//   contentfulClientConfig['host'] = 'preview.contentful.com';
//   contentfulClientConfig['accessToken'] = 'c8cd3c5194ff44e9c197f2bd3e0e61abb2b7a3599e9efed73cfa6330a5bacfb4';
// }

export const contentfulClient = createClient(contentfulClientConfig);

GA.initialize("UA-113010255-1", {
  debug: true,
  titleCase: false,
});

const history = createHistory();

history.listen((location, action) => {
  GA.set({ page: location.pathname });
  GA.pageview(location.pathname);
});

class App extends Component {
  componentWillMount() {
    this.props.initialFetch();
  }

  render() {
    return (
      <StyleRoot>
        <Router history={history}>
          <ScrollToTop>
            <div className="container">
              <div className="content">
                <FixedHeader />
                <Menu />

                <div>
                  <Route exact path="/" component={Home} />
                  <Route path="/post/:id" component={Post} />
                  <Route path="/about" component={About} />
                  <Route path="/news" component={Archives} />
                  <Route path="/trends" component={Trends} />
                  <Route path="/humanly" component={Trends} />
                  <Route path="/request" component={Request} />
                </div>
              </div>
            </div>
            <div className="container" style={{ backgroundColor: "#EEE" }}>
              <div className="content">
                <Footer footer={this.props.footer} />
              </div>
            </div>
          </ScrollToTop>
        </Router>
      </StyleRoot>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    homePage: state.homePage,
    posts: state.posts,
    footer: state.footer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    initialFetch() {
      contentfulClient.getEntries({ content_type: "footer" }).then((response) => {
        dispatch({ type: "LOAD_FOOTER", content: response });
      });

      contentfulClient
        .getEntries({ content_type: "homePage" })
        .then((response) => {
          dispatch({ type: "LOAD_HOME_PAGE", content: response });
          return contentfulClient.getEntries({ content_type: "post" });
        })
        .then((response) => {
          dispatch({ type: "LOAD_POSTS", content: response });
        });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js